import { Dropdown, Flexbox, Typography } from '@doc/ui-components';
import { AbbGlobe } from '@doc/ui-components/icons';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useLocale } from 'next-intl';
import { useTheme } from 'next-themes';
import type { HeaderProps } from '../types/header.type';

export const LanguageMenu = ({ supportedLocales, locales }: Pick<HeaderProps, 'supportedLocales' | 'locales'>) => {
	const { resolvedTheme } = useTheme();
	const router = useRouter();
	const pathname = usePathname();
	const params = useSearchParams();
	const selectedLanguage = useLocale();
	const segments = pathname.split('/').filter(Boolean).slice(1).join('/');

	const languages =
		supportedLocales.map((item) => ({
			value: item,
			label: <span className='capitalize text-dark'>{locales[item]?.nativeName}</span>,
			onClick: () => {
				router.replace(params.size > 0 ? `/${item}/${segments}?${params.toString()}` : `/${item}/${segments}`, {
					scroll: false,
				});
			},
		})) ?? [];

	return (
		<Flexbox className='w-fit' items='center' justify='center'>
			<Dropdown
				arrowIcon
				label={
					<>
						<AbbGlobe className='mr-2' size={24} fill={resolvedTheme === 'dark' ? '#f1f1f1' : '#1f1f1f'} />
						<Typography size='text-base' weight='font-semibold'>
							{locales[selectedLanguage]?.nativeName}
						</Typography>
					</>
				}
				menuItems={languages}
			/>
		</Flexbox>
	);
};
